/* eslint-disable import/no-anonymous-default-export */

import DemandCollectionActionTypes from './demand-collection-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getDemandCollectionListResponse: null,
	getDemandCollectionListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET DEMAND COLLECTION LIST START *********************** */
		case DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_SUCCESS:
			return {
				...state,
				getDemandCollectionListResponse: action.payload,
				getDemandCollectionListArr: docodeHexResponse(
					action.payload,
					'DemandCollectionKey',
				),
			};

		case DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_FAILURE:
			return { ...state, getDemandCollectionListResponse: action.payload };

		case DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_RESPONSE_CHANGED:
			return { ...state, getDemandCollectionListResponse: null };
		/** ***************** GET DEMAND COLLECTION LIST END *********************** */

		default:
			return state;
	}
};
